import { render, staticRenderFns } from "./listaPedidos.vue?vue&type=template&id=29223270&scoped=true"
import script from "./listaPedidos.vue?vue&type=script&lang=js"
export * from "./listaPedidos.vue?vue&type=script&lang=js"
import style0 from "./listaPedidos.vue?vue&type=style&index=0&id=29223270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29223270",
  null
  
)

export default component.exports